import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import Tabela2 from "../../../Componentes/Utils/Tabela2";
import { useEffect, useState } from "react";
import MultiselectCheck from "../../../Componentes/Utils/MultiselectCheck";
import axios from "axios";
import ModalNovaArea from "./ModalNovaArea";
import { BsTrash3 } from "react-icons/bs";
import ModalDeleteArea from "./ModalDeleteArea";

const Container = styled.div`
    width: 100%;
    height: 350px;
`
const ContainerTitulo = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    height: 40px;
`
const BotaoAdd = styled.button`
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    &:hover {
        background-color: #0056b3;
    }
`
const TituloModal = styled.h2`
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: #333;
`
const CelulaTh = styled.th`
    width: 31%;
`
const CelulaTd = styled.td`
    width: 31%;
`
const InputFiltro = styled.input`
    width: 100%;
    height: 34px;
    box-sizing: border-box;
    padding: 6px 8px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid #ddd;
    outline: none;
    &:focus {
        border-color: #007bff;
        box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
`
const CelulaDelete = styled.td`
    
`

const ContainerIconeTrash = styled.div`
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
`
const IconeTrash = styled(BsTrash3)`
    color: red;
    width: 100%;
    height: 100%;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
        scale: 1.1;
    }
    transition: all 0.2s ease-in-out;
`

const AreasCatalogo = () => {

    const { closeModal, isModalOpen, openModal } = useModal();

    const [data, setData] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);

    const getData = async () => {

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/GetAreasCatalogo/');

            setData(data);
            setDataFiltered(data);

        } catch (error) {

            console.error(error);

        }

    }

    useEffect(() => {

        getData();

    }, [])

    // Removendo null, "", undefined e strings só com espaços
    const centroCustoOptions = [...new Set(data.map(item => item.obra).filter(v => v != null && String(v).trim() !== ""))].sort().map(cc => ({ label: cc, value: cc }));
    const contratoOptions = [...new Set(data.map(item => item.contrato).filter(v => v != null && String(v).trim() !== ""))].sort().map(ct => ({ label: ct, value: ct }));

    const [selectedCentroCusto, setSelectedCentroCusto] = useState([]);
    const [selectedContrato, setSelectedContrato] = useState([]);
    const [area, setArea] = useState('');

    useEffect(() => {

        let filtered = data;
        if (selectedCentroCusto.length > 0) {
            filtered = filtered.filter(item => selectedCentroCusto.includes(item.obra));
        }
        if (selectedContrato.length > 0) {
            filtered = filtered.filter(item => selectedContrato.includes(item.contrato));
        }
        if (area.trim() !== '') {
            filtered = filtered.filter(item => item.area.toLowerCase().includes(area.toLowerCase()));
        }
        setDataFiltered(filtered);

    }, [selectedCentroCusto, selectedContrato, area, data]);

    const [selectedArea, setSelectedArea] = useState(null);

    const openDeleteModal = (area) => {

        setSelectedArea(area);
        openModal("deleteAreaCatalogo");

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={closeModal} size="lg" >
                    <ContainerTitulo>
                        <TituloModal>CATÁLOGO DE ÁREAS</TituloModal>
                        <BotaoAdd onClick={() => openModal("novaAreaCatalogo")} >
                            ADICIONAR ÁREA
                        </BotaoAdd>
                    </ContainerTitulo>
                    <Container>
                        <Tabela2>
                            <thead>
                                <tr>
                                    <CelulaTh>CENTRO CUSTO</CelulaTh>
                                    <CelulaTh>CONTRATO</CelulaTh>
                                    <CelulaTh>ÁREA</CelulaTh>
                                    <CelulaTh />
                                </tr>
                                <tr>
                                    <CelulaTh>
                                        <MultiselectCheck options={centroCustoOptions} selectedOptions={selectedCentroCusto} setSelectedOptions={setSelectedCentroCusto} />
                                    </CelulaTh>
                                    <CelulaTh>
                                        <MultiselectCheck options={contratoOptions} selectedOptions={selectedContrato} setSelectedOptions={setSelectedContrato} />
                                    </CelulaTh>
                                    <CelulaTh>
                                        <InputFiltro
                                            type="text"
                                            placeholder="DIGITE A ÁREA..."
                                            value={area}
                                            onChange={(e) => setArea(e.target.value)}
                                        />
                                    </CelulaTh>
                                    <CelulaTh />
                                </tr>
                            </thead>
                            <tbody>
                                {dataFiltered.map((area) => (
                                    <tr key={area.id}>
                                        <CelulaTd>{area.obra}</CelulaTd>
                                        <CelulaTd>{area.contrato}</CelulaTd>
                                        <CelulaTd>{area.area}</CelulaTd>
                                        <CelulaDelete>
                                            <ContainerIconeTrash>
                                                <IconeTrash onClick={() => openDeleteModal(area)} />
                                            </ContainerIconeTrash>
                                        </CelulaDelete>
                                    </tr>
                                ))}
                            </tbody>
                        </Tabela2>
                    </Container>
                </Modal>
                {
                    isModalOpen("novaAreaCatalogo") && (
                        <ModalNovaArea
                            updateAreasCatalogo={ getData }
                        />
                    )
                }
                {
                    isModalOpen("deleteAreaCatalogo") && (
                        <ModalDeleteArea
                            obj={ selectedArea }
                            setSelectedArea={ setSelectedArea }
                            updateAreas={ getData }
                        />
                    )
                }
            </Overlay>
        </>
    )
}

export default AreasCatalogo;